/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import auth from './auth';
import productStore from './products'
import eBoekhouden from './eBoekhouden';
import packages from './packages'
import sendOptions from './sendOptions';
import userStore from './user';
import openOrdersStore from './openOrders';
import retailerSetting from './retailerSetting';
import NotificationsSettings from './NotificationsSettings';
import subscriptions from './subscriptions';
import moneybird from './moneybird';
import dymoStore from './settings/dymo';
import sendCloud from './sendCloud';
import salesValues from './analytics/salesValues';
import deliveryTime from './deliverytime';
import dashboard from './dashboard';
import orderHistory from './orderHistory';
import orderDropship from './orderDropship';
import wiki from './wiki';
import lightspeed from './modules/webshop/lightspeed';
import promotion from './modules/promotion/promotion';
import invoices from './modules/accounting/invoices';
import pools from './modules/inventory/pools';
import poolsData from './modules/inventory/poolsData';


Vue.use(Vuex);

export default new Vuex.Store({
	getters,
	mutations,
	state,
	actions,
	modules: {
		auth,
		salesValues,
		userStore,
		retailerSetting,
		eBoekhouden,
		productStore,
		sendOptions,
		NotificationsSettings,
		subscriptions,
		moneybird,
		packages,
		dymoStore,
		openOrdersStore,
		sendCloud,
		deliveryTime,
		dashboard,
		orderHistory,
		orderDropship,
		wiki,
		lightspeed,
		promotion,
		invoices,
		pools,
		poolsData,
	},
	strict: process.env.NODE_ENV !== 'production'
})
